import React from "react";

class JirangoLink extends React.Component {
    state = {
        mouseOver: false
    }
    mouseEnter = () => {
        this.setState({ mouseOver: true });
    }
    mouseLeave = () => {
        this.setState({ mouseOver: false });
    }
    render() {
        const { style, children, onClick, disabled } = this.props;
        let linkStyle = this.state.mouseOver ?
            {
                ...style,
                color: style["&:hover"].color,
                textDecoration: style["&:hover"].textDecoration,
                cursor: 'pointer'

            } : style;
        return (
            <a
                disabled={disabled}
                style={linkStyle}
                onClick={onClick}
                onMouseEnter={this.mouseEnter}
                onMouseLeave={this.mouseLeave}
            >
                {children}
            </a>
        );
    }

};
export default JirangoLink;
